import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['input']

    connect() {
        this.editor = new EasyMDE({
            element: this.inputTarget,
            spellChecker: false,
            autosave: { enabled: false },
            toolbar: [
                'bold', 'italic', 'strikethrough', '|',
                'heading-1', 'heading-2', 'heading-3', '|',
                'unordered-list', 'ordered-list', '|',
                'link', 'image', 'upload-image', 'table', '|',
                'code', 'quote', '|',
                'horizontal-rule', '|',
                'preview', 'side-by-side', 'fullscreen', '|',
                'guide'
            ],
            uploadImage: true,
            imageUploadFunction: this.uploadImage.bind(this),
            imageTexts: {
                sbInit: '拖拽或粘贴图片上传',
                sbOnDragEnter: '松开鼠标上传图片',
                sbOnDrop: '正在上传图片…',
                sbProgress: '正在上传 #file_name#: #progress#%',
                sbOnUploaded: '图片上传完成',
                sizeUnits: 'B, KB, MB'
            },
            renderingConfig: {
                singleLineBreaks: false,
                codeSyntaxHighlighting: true
            },
            sideBySideFullscreen: false,
        })

        this.editor.toggleSideBySide()

        // 表单提交前确保内容同步到 textarea
        this.inputTarget.closest('form')?.addEventListener('submit', () => {
            this.inputTarget.value = this.editor.value()
        })
    }

    disconnect() {
        this.editor?.toTextArea()
        this.editor = null
    }

    uploadImage(file, onSuccess, onError) {
        const formData = new FormData()
        formData.append('file', file)

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        if (!csrfToken) {
            onError('CSRF token not found')
            return
        }

        fetch('/backend/image_uploads', {
            method: 'POST',
            body: formData,
            headers: { 'X-CSRF-Token': csrfToken }
        })
            .then(r => r.json())
            .then(data => {
                if (data.path) {
                    onSuccess(data.path)
                } else {
                    onError(data.error || '上传失败')
                }
            })
            .catch(() => onError('网络错误，上传失败'))
    }
}
